// Access tier canon — locked. Single source of truth for tier display + checkout SKU.
import { ACCESS_SKUS } from "@/lib/sku";

export const TIERS = [
    {
        id: "foundation",
        name: "FOUNDATION",
        price: "$444.44",
        tagline: "Begin the build path.",
        benefits: [
            "Full A–H system access",
            "Build Path / Letter / Phase unlocks",
            "Offline downloadable system",
            "Smithers offline guidance",
        ],
        accent: "cyan",
        cta: "Choose Foundation",
        primary: false,
        sku: ACCESS_SKUS.foundation.FULL,
    },
    {
        id: "architect",
        name: "ARCHITECT",
        price: "$888.88",
        tagline: "Architect-level depth.",
        benefits: [
            "Everything in Foundation",
            "Advanced architecture playbooks",
            "Priority Smithers guidance",
            "Architect-tier doctrine",
        ],
        accent: "cyan",
        cta: "Choose Architect",
        primary: false,
        sku: ACCESS_SKUS.architect.FULL,
    },
    {
        id: "system",
        name: "SYSTEM",
        price: "$1,111.11",
        tagline: "Most chosen.",
        benefits: [
            "Everything in Architect",
            "Live dashboard access",
            "Full ecosystem integration",
            "Workshop environment",
        ],
        accent: "cyan-strong",
        cta: "Choose System",
        primary: true,
        ribbon: "MOST CHOSEN",
        sku: ACCESS_SKUS.system.FULL,
    },
    {
        id: "genesis",
        name: "GENESIS",
        price: "$1,777.77",
        tagline: "Total ecosystem access.",
        benefits: [
            "Everything in System",
            "Future A–Z expansion modules",
            "Enterprise-grade frameworks",
            "Orchestration systems access",
        ],
        accent: "gold",
        cta: "Choose Genesis",
        primary: false,
        sku: ACCESS_SKUS.genesis.FULL,
    },
];
